import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import Avatar from "@mui/material/Avatar";
import Hoot from "../../Hoot";
import ClickAllRefreshButtons from "../../ClickAllRefreshButtons";

function normalize(str) {
  return str ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : "";
}

const provinciasCidades = {
  bengo: ["Bengo", "Caxito"],
  benguela: ["Benguela"],
  bie: ["Bié", "Kuito"],
  cabinda: ["Cabinda"],
  "cuando cubango": ["Cuando Cubango", "Menongue"],
  "cuanza norte": ["Cuanza Norte", "Ndalatando"],
  "cuanza sul": ["Cuanza Sul", "Sumbe"],
  cunene: ["Cunene", "Ondjiva"],
  huambo: ["Huambo"],
  huila: ["Huíla", "Lubango"],
  luanda: ["Luanda"],
  "lunda norte": ["Lunda Norte", "Dundo"],
  "lunda sul": ["Lunda Sul", "Saurimo"],
  malanje: ["Malanje"],
  moxico: ["Moxico", "Luena"],
  namibe: ["Namibe", "Mocamedes"],
  uige: ["Uíge"],
  zaire: ["Zaire", "M'Banza Congo"],
};

function mapProvinceToSelect(provinceFromDB) {
  const normalizedDB = normalize(provinceFromDB);
  for (const key of Object.keys(provinciasCidades)) {
    const aliases = provinciasCidades[key];
    if (aliases.some((a) => normalize(a) === normalizedDB)) return key;
  }
  return "";
}

function prettyProvinceLabel(key) {
  return provinciasCidades[key]?.[0] || key;
}

const styles = `
.pretty-modal .modal-dialog{
  max-width: 720px;
}
@media (max-width: 768px){
  .pretty-modal .modal-dialog{ max-width: 96vw; }
}
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-title{
  font-weight: 650;
  color: #0f172a;
  font-size: 1rem;
}
.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}
.body-scroll{
  max-height: 500px;
  overflow-y: auto;
  padding-right: 4px;
}
.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}
.header-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
}
.header-left{
  display:flex;
  align-items:center;
  gap:12px;
}
.avatar-wrap{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(91,92,255,.10);
  border: 1px solid rgba(91,92,255,.18);
  display:grid;
  place-items:center;
}
.title-sub{
  margin-top:2px;
  font-size: .8rem;
  color: #64748b;
  font-weight: 500;
}
.form-grid{
  display:grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}
@media (max-width: 720px){
  .form-grid{ grid-template-columns: 1fr; }
}
.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem;
  color:#64748b;
  font-weight: 600;
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom: 8px;
}
.req{
  color:#ef4444;
  font-weight:700;
}
.form-label{
  font-size: .78rem !important;
  color: #475569 !important;
  font-weight: 600 !important;
  margin-bottom: 6px !important;
}
.form-control, .form-select{
  border-radius: 12px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}
.helper{
  font-size: .74rem;
  color:#64748b;
  margin-top: 6px;
}
.upload-row{
  display:flex;
  align-items:flex-start;
  gap:12px;
  flex-wrap:wrap;
}
.preview-box{
  width: 96px;
  height: 96px;
  border-radius: 18px;
  border: 1px dashed rgba(148,163,184,.55);
  background: rgba(248,250,252,.75);
  display:grid;
  place-items:center;
  overflow:hidden;
}
.preview-note{
  font-size:.72rem;
  color:#94a3b8;
  padding: 0 10px;
  text-align:center;
}
.actions{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  flex-wrap:wrap;
}
.btn-soft{
  border-radius: 999px !important;
  border: 1px solid rgba(226,232,240,.95) !important;
  background: #fff !important;
}
.btn-primary{
  border-radius: 999px !important;
}
`;

const initialContact = {
  ed_contact_name: "",
  ed_contact_phone: "",
  ed_contact_email: "",
  ed_contact_country: "",
  ed_contact_address: "",
  ed_contact_type: "",
  ed_contact_picture: null,
  ed_contact_comercial: "",
  ed_contact_province: "",
};

//  helper para aceitar tanto array como {data:[]}
function asArray(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

export default function RegisterOrUpdateContactModal({
  update = false,
  contactId = null,
  toggle_btn,
}) {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState(null);
  const [contact, setContact] = useState(initialContact);

  //  Comerciais via endpoint
  const [comerciais, setComerciais] = useState([]);
  const [comerciaisLoading, setComerciaisLoading] = useState(false);
  const [comerciaisError, setComerciaisError] = useState(null);

  const openModal = () => setShow(true);

  const closeModal = () => {
    if (loading) return;
    setShow(false);
    setLoading(false);
    setError(null);
    setPreview(null);
    setContact(initialContact);
    setComerciaisError(null);
  };

  const provinceOptions = useMemo(() => {
    return Object.keys(provinciasCidades)
      .map((key) => ({ key, label: prettyProvinceLabel(key) }))
      .sort((a, b) => a.label.localeCompare(b.label, "pt"));
  }, []);

  //  carregar comerciais quando abre modal
  useEffect(() => {
    if (show) loadComerciais();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  //  carregar contacto quando update
  useEffect(() => {
    if (show && update && contactId) loadContactData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, update, contactId]);

  //  CORREÇÃO: endpoint devolve {data:[...]} e tem paginação
  // Aqui pedimos limit=200 e status=ativo para garantir que aparece
  const loadComerciais = async () => {
    try {
      setComerciaisLoading(true);
      setComerciaisError(null);

      const res = await axios.get(`${Hoot()}comerciais`, {
        withCredentials: true,
        params: {
          page: 1,
          limit: 200,
          status: "ativo", // se quiseres todos, remove isto
        },
      });

      const data = asArray(res.data);

      // (extra segurança) filtra inativo caso backend ignore status
      const onlyActive = data.filter((c) => String(c?.status || "").toLowerCase() !== "inativo");

      // Ordenar por nome
      onlyActive.sort((a, b) => String(a?.name || "").localeCompare(String(b?.name || ""), "pt"));

      setComerciais(onlyActive);
    } catch (e) {
      setComerciais([]);
      setComerciaisError("Erro ao carregar comerciais.");
    } finally {
      setComerciaisLoading(false);
    }
  };

  const loadContactData = async () => {
    try {
      setError(null);
      const res = await axios.get(`${Hoot()}contactsbyid/${contactId}`, {
        withCredentials: true,
      });
      const data = res.data?.data;

      setContact({
        ed_contact_name: data?.ed_contact_name || "",
        ed_contact_phone: data?.ed_contact_phone || "",
        ed_contact_email: data?.ed_contact_email || "",
        ed_contact_country: data?.ed_contact_country || "",
        ed_contact_comercial: data?.ed_contact_comercial || "",
        ed_contact_address: data?.ed_contact_address || "",
        ed_contact_type: data?.ed_contact_type ?? 0,
        ed_contact_picture: null,
        ed_contact_province: mapProvinceToSelect(data?.ed_contact_province || ""),
      });

      setPreview(data?.ed_contact_picture ? data.ed_contact_picture : null);
    } catch (err) {
      setError("Erro ao carregar os dados do contacto.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContact((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    setContact((prev) => ({ ...prev, ed_contact_picture: file || null }));

    if (!file) {
      setPreview(null);
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError(null);

    const formData = new FormData();
    Object.entries(contact).forEach(([key, value]) => {
      if (value !== null && value !== undefined) formData.append(key, value);
    });

    try {
      if (update && contactId) {
        await axios.put(`${Hoot()}contacts/update/${contactId}`, formData, {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Contacto atualizado com sucesso!");
      } else {
        await axios.post(`${Hoot()}contacts/create`, formData, {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Contacto registado com sucesso!");
      }

      closeModal();
      ClickAllRefreshButtons();
    } catch (err) {
      setError("Erro ao salvar contacto.");
      setLoading(false);
    }
  };

  return (
    <>
      <style>{styles}</style>

      <div onClick={openModal} style={{ display: "inline-block" }}>
        {toggle_btn}
      </div>

      <Modal
        show={show}
        onHide={closeModal}
        centered
        backdrop="static"
        keyboard={!loading}
        className="pretty-modal"
      >
        <Modal.Header closeButton={!loading}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="avatar-wrap">
                <i className="bi bi-person-vcard" style={{ color: "#5b5cff", fontSize: 18 }} />
              </div>

              <div>
                <div style={{ fontWeight: 650 }}>
                  {update ? "Atualizar contacto" : "Registar contacto"}
                </div>
                <div className="title-sub">Preenche os campos essenciais de forma organizada.</div>
              </div>
            </div>

            {preview ? (
              <Avatar src={preview} alt="Preview" sx={{ width: 44, height: 44, borderRadius: 3 }} />
            ) : null}
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="body-scroll">
            {error && (
              <Alert variant="danger" className="mb-3" style={{ borderRadius: 14 }}>
                {error}
              </Alert>
            )}

            <Form id="contact-form" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-card-text" />
                    Identificação
                  </div>

                  <div className="form-grid">
                    <Form.Group>
                      <Form.Label>
                        Nome <span className="req">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="ed_contact_name"
                        value={contact.ed_contact_name}
                        onChange={handleChange}
                        required
                        placeholder="Ex.: Colégio X"
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>
                        Tipo <span className="req">*</span>
                      </Form.Label>
                      <Form.Select
                        name="ed_contact_type"
                        value={contact.ed_contact_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="">-- Selecionar --</option>
                        <option value="0">Colégio</option>
                        <option value="1">Universidade</option>
                      </Form.Select>
                    </Form.Group>
                  </div>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-telephone" />
                    Contacto
                  </div>

                  <Form.Group className="mb-2">
                    <Form.Label>
                      Telefone <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="ed_contact_phone"
                      value={contact.ed_contact_phone}
                      onChange={handleChange}
                      required
                      placeholder="Ex.: +244 9xx xxx xxx"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>
                      Email <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="ed_contact_email"
                      value={contact.ed_contact_email}
                      onChange={handleChange}
                      required
                      placeholder="Ex.: escola@email.com"
                    />
                  </Form.Group>
                </div>

                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-geo-alt" />
                    Localização
                  </div>

                  <Form.Group className="mb-2">
                    <Form.Label>
                      País <span className="req">*</span>
                    </Form.Label>
                    <Form.Select
                      name="ed_contact_country"
                      value={contact.ed_contact_country}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Selecionar País --</option>
                      <option value="Angola">Angola</option>
                      <option value="Brasil">Brasil</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Moçambique">Moçambique</option>
                      <option value="Cabo Verde">Cabo Verde</option>
                      <option value="Guiné-Bissau">Guiné-Bissau</option>
                      <option value="São Tomé e Príncipe">São Tomé e Príncipe</option>
                      <option value="Timor-Leste">Timor-Leste</option>
                      <option value="Guiné Equatorial">Guiné Equatorial</option>
                      <option value="Outros">Outros</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-2">
                    <Form.Label>
                      Província <span className="req">*</span>
                    </Form.Label>
                    <Form.Select
                      name="ed_contact_province"
                      value={contact.ed_contact_province}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Selecionar Província --</option>
                      {provinceOptions.map((p) => (
                        <option key={p.key} value={p.key}>
                          {p.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>
                      Endereço <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="ed_contact_address"
                      value={contact.ed_contact_address}
                      onChange={handleChange}
                      required
                      placeholder="Rua, bairro, referência..."
                    />
                  </Form.Group>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-person-badge" />
                    Comercial
                  </div>

                  <Form.Group>
                    <Form.Label>
                      Comercial responsável <span className="req">*</span>
                    </Form.Label>

                    <Form.Select
                      name="ed_contact_comercial"
                      value={contact.ed_contact_comercial}
                      onChange={handleChange}
                      required
                      disabled={comerciaisLoading}
                    >
                      <option value="">
                        {comerciaisLoading ? "A carregar comerciais..." : "-- Selecionar --"}
                      </option>

                      {comerciais.map((c) => (
                        <option key={c.id} value={c.name}>
                          {c.name}
                        </option>
                      ))}
                    </Form.Select>

                    {comerciaisError ? (
                      <div className="helper" style={{ color: "#ef4444" }}>
                        {comerciaisError}{" "}
                        <span
                          style={{ textDecoration: "underline", cursor: "pointer" }}
                          onClick={loadComerciais}
                        >
                          Tentar novamente
                        </span>
                      </div>
                    ) : (
                      <div className="helper">Quem ficará responsável por acompanhar este contacto.</div>
                    )}
                  </Form.Group>
                </div>

                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-image" />
                    Foto
                  </div>

                  <div className="upload-row">
                    <div className="preview-box">
                      {preview ? (
                        <img
                          src={preview}
                          alt="Preview"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div className="preview-note">Sem foto</div>
                      )}
                    </div>

                    <div style={{ flex: 1, minWidth: 220 }}>
                      <Form.Label style={{ marginTop: 2 }}>Escolher ficheiro</Form.Label>
                      <Form.Control type="file" accept="image/*" onChange={handleFileChange} />
                      <div className="helper">Use uma imagem leve para melhor desempenho.</div>
                    </div>

                    {preview ? (
                      <div style={{ marginLeft: "auto" }}>
                        <Avatar src={preview} alt="Preview" sx={{ width: 84, height: 84, borderRadius: 4 }} />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="actions" style={{ width: "100%" }}>
            <Button
              type="button"
              variant="outline-secondary"
              className="btn-soft"
              onClick={closeModal}
              disabled={loading}
            >
              Cancelar
            </Button>

            <Button type="submit" variant="primary" form="contact-form" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  A guardar...
                </>
              ) : update ? (
                "Atualizar"
              ) : (
                "Registar"
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
